define('setup/error/error',['require','knockout','api-access','plugins/router','i18next'],function (require) {
    var ko = require('knockout');
    var userApi = require('api-access').user;
    var router = require('plugins/router');
    var i18n = require('i18next');

    return function () {
        var self = this;

        self.tryAgain = function () {
            window.location.reload();
        };

        self.activate = function () {
            self.welcomeText = ko.observable();
            userApi.me().then(function (me) {
                self.welcomeText(i18n.t('setup.common.welcome', me.firstName));
            });
            userApi.getServiceStatus().then(function (status) {
                if (status['gotomeetme-service'].up) {
                    router.navigate('#setup');
                }
            });
        };
    };
});

